import type { AddContactContactType } from "@/Shared/Types/contactTypes";
import type { AddLocationAddressType } from "@/Shared/Types/locationTypes";
import type { Address } from "@freightsimple/generated-dashboard-openapi-client/models/Address";
import type { Contact } from "@freightsimple/generated-dashboard-openapi-client/models/Contact";

export type AddBrokerBrokerType = {
  businessName?: string | undefined;
  accountNumber?: string | undefined;
  address: AddLocationAddressType | Address;
  contact: AddContactContactType | Contact;
};

export function emptyBrokerInfo(): AddBrokerBrokerType {
  return {
    businessName: undefined,
    accountNumber: undefined,
    address: {},
    contact: {},
  };
}
